import Typography from "../../atoms/typography/Typography";

const Text = ({ variant, children, className }) => {
  return (
    <Typography variant={variant} className={className}>
      {children}
    </Typography>
  );
};

export default Text;
